import { render, staticRenderFns } from "./GSwitch.vue?vue&type=template&id=09de0fc3&"
import script from "./GSwitch.vue?vue&type=script&lang=js&"
export * from "./GSwitch.vue?vue&type=script&lang=js&"
import style0 from "./GSwitch.vue?vue&type=style&index=0&id=09de0fc3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports